module.exports = __webpack_public_path__ + "static/img/newanli-22.eaf433e3.jpg";